import { formatPhoneNumber } from "../utils/phone";
import mapKnownValues from "../utils/mapKnownValues";
import { TransferDestinationPlanType } from "./transferDestination";

export type Plan = {
  planName: string | null;
  planNumber: string | null;
  planType: TransferDestinationPlanType | null;
};

export type UserEmployerDetailsResponse = {
  enableEmployerSpecificFlows: boolean;
  employerName: string | null;
  employerHREmail: string;
  employerHRPhoneNumber: string;
  employerProviderName: string | null;
  plans: Plan[];
  planChangeData?: {
    planChange: boolean;
    oldEmployerName?: string;
    oldProviderName?: string;
    oldPlanType?: string;
  };
  disableReallocation: boolean;
};

export default class UserEmployerDetails {
  enableEmployerSpecificFlows = false;
  employerName = "";
  employerHREmail = "";
  employerHRPhoneNumber = "";
  employerProviderName = "";
  plans: Plan[] = [];
  disableReallocation = false;
  planChangeData: UserEmployerDetailsResponse["planChangeData"] | null = null;

  constructor(params: Partial<UserEmployerDetails> = {}) {
    mapKnownValues(this, params);
  }

  // In case the phone number can't be formatted, we just show the original
  get formattedPhoneNumber() {
    const formattedNumber = formatPhoneNumber(`+${this.employerHRPhoneNumber}`);
    return formattedNumber ? `+${this.employerHRPhoneNumber.charAt(0)} ${formattedNumber}` : this.employerHRPhoneNumber;
  }

  get hasPlanChange() {
    return this.planChangeData?.planChange === true;
  }

  get isMA() {
    return this.planChangeData?.planChange === true && this.planChangeData.oldEmployerName !== null;
  }

  get isPlanConversion() {
    return this.planChangeData?.planChange === true && this.planChangeData.oldEmployerName === null;
  }

  static fromAPI(response: UserEmployerDetailsResponse) {
    return new UserEmployerDetails({
      ...response,
      employerName: response.employerName || "",
      employerProviderName: response.employerProviderName || "",
      plans: response.plans,
    });
  }
}
